module.exports = __webpack_public_path__ + "static/media/stephen-taylor-data-logo-min.e77b881f.svg";